<template>
<div>
        <h1 class="h2 title" v-if="element == 'h1'" v-html="returnTitle"></h1>
        <div class="my-4"  v-if="element == 'div'"  v-html="returnDescription"></div>
</div>
</template>
<script>
export default {

    props:
    {
        // variationProperties
        properties:
        {
            type: [Object, Array]
        },
        // Standard Text
        texts:
        {
            type: String
        },
        // HTML-Element
        element:
        {
            type: String
        }
    },

    computed:{
        returnDescription()
        {
          if (!this.properties)
          {
              return this.texts;
          };
          return this.getText(parseInt(App.configKS.item.propertyDescription));
        },
       // Debug
        showConfig()
        {
          return {
            "desc": App.configKS.item.propertyDescription,
            "title": App.configKS.item.propertyTitle,
            "isProperties": this.properties ? true : false
          }
        },
        returnTitle()
        {
          if (!this.properties)
          {
              return this.texts;
          };
          return this.getText(parseInt(App.configKS.item.propertyTitle));
        }
    },
    methods:
    {
      getText(propertyId)
      {
        let isText = "";
        if (propertyId)
        {
            this.properties.forEach((group) => {
              if (group["id"] == 7)
              {
                group['properties'].forEach((property) => {
                  if (property.id == propertyId && property.values.value.length > 0 )
                  {
                    isText = property.values.value;
                  }
                });
              }
            });
        }
        if (isText)
        {
            return isText;
        }
        return this.texts;
      }
    }
}
</script>
